import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import { useInvalidateCompaniesList } from '@/entities/company';
import { deleteCompanyById } from '@/shared/api/companies';
import { useGetConfirmation } from '@/shared/ui/Confirmations/confirmation';

export function useDeleteCompany() {
  const { t } = useTranslation();
  const invalidateCompaniesList = useInvalidateCompaniesList();
  const { getConfirmation, setPending, closeConfirmation } =
    useGetConfirmation();

  const deleteCompanyMutation = useMutation({
    mutationFn: (channelId: string): Promise<void> =>
      deleteCompanyById(channelId),
    onSuccess: async () => {
      closeConfirmation();
      await invalidateCompaniesList();
    },
    onSettled: () => {
      setPending(false);
    },
  });

  const deleteCompany = async (channelId: string): Promise<void> => {
    const isConfirm = await getConfirmation({
      shouldCloseOnConfirm: false,
      title: t('company:deleteDialog.title'),
      description: t('company:deleteDialog.description'),
      confirmText: t('company:deleteDialog.confirmText'),
    });

    if (!isConfirm) return;

    setPending(true);
    return deleteCompanyMutation.mutateAsync(channelId);
  };

  return {
    deleteCompany,
    ...deleteCompanyMutation,
  };
}
